function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/allplaceapplication/download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/allplaceapplication/download (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h19v17H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.175 15.734a2.253 2.253 0 0 1-2.2-2.7l-.983-.571L9.156 14.1a.888.888 0 0 1-.887 0l-2.837-1.638-.982.571a2.26 2.26 0 0 1-1.082 2.4A2.239 2.239 0 0 1 .3 14.6a2.268 2.268 0 0 1 .826-3.084 2.24 2.24 0 0 1 2.606.258l1.068-.617V8.1a.889.889 0 0 1 .444-.769l2.744-1.579V4.4a2.259 2.259 0 1 1 1.453 0v1.352l2.742 1.579a.888.888 0 0 1 .444.769v3.059l1.069.619a2.238 2.238 0 0 1 2.604-.258 2.26 2.26 0 0 1-1.126 4.214zm0-3.225a.968.968 0 0 0-.483 1.8.957.957 0 0 0 .479.129.967.967 0 0 0 .483-1.8.957.957 0 0 0-.476-.129zm-12.932 0a.983.983 0 0 0-.125.008.968.968 0 0 0-.805.708.966.966 0 0 0 .1.735.967.967 0 0 0 .587.448.975.975 0 0 0 .249.033.941.941 0 0 0 .126-.009.967.967 0 0 0-.125-1.926zm6.464-5.5L6.251 8.427v2.831l2.461 1.418 2.461-1.418V8.427L8.711 7.008zm0-5.7a.967.967 0 0 0-.967.949.968.968 0 0 0 1.936 0 .968.968 0 0 0-.968-.949z",
    transform: "translate(.788 .633)",
    style: {
      fill: "current"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingRoom);
export default __webpack_public_path__ + "static/media/meetingRoom.c4e896f76d43414713029987a93713dc.svg";
export { ForwardRef as ReactComponent };